import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Phone, MapPin, MessageCircle } from "lucide-react";
import { api, IMAGES } from "../lib/api";

export default function Footer() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  const hours = settings?.opening_hours || {};

  return (
    <footer className="border-t border-white/10 bg-[#0a0a0a] mt-24 no-print" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <img src={IMAGES.logo} alt="Italian Club" className="h-20 w-20 object-contain rounded-full bg-white/95 p-1 mb-4" />
          <p className="font-serif-elegant text-2xl text-[#D4AF37]">Italian Club</p>
          <p className="text-sm text-gray-400 mt-2">Bar · Restaurant · Live Music</p>
          <div className="tricolore mt-4"><span /><span /><span /></div>
          <p className="text-sm text-gray-400 mt-6 leading-relaxed">
            Restaurant italien avec terrasse à Champs-sur-Marne — cuisine italienne, musique live, mariages et événements privés.
          </p>
        </div>
        <div>
          <p className="gold-label mb-5">Horaires d'ouverture</p>
          <ul className="space-y-2 text-sm">
            {Object.entries(hours).map(([day, h]) => (
              <li key={day} className="flex justify-between text-gray-300">
                <span>{day}</span>
                <span className="text-gray-400">{h}</span>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="gold-label mb-5">Contact</p>
          <ul className="space-y-4 text-sm text-gray-300">
            <li className="flex items-start gap-3">
              <MapPin size={16} className="text-[#D4AF37] mt-0.5" />
              <span>{settings?.address || "36 Rue de Paris, 77420 Champs-sur-Marne"}</span>
            </li>
            <li>
              <a href={`tel:${(settings?.phone || "0180814365").replace(/\s/g, "")}`} data-testid="footer-phone-link" className="flex items-center gap-3 hover:text-[#D4AF37]">
                <Phone size={16} className="text-[#D4AF37]" /> {settings?.phone || "01 80 81 43 65"}
              </a>
            </li>
            <li>
              <a href={`https://wa.me/${(settings?.whatsapp || "+33180814365").replace(/[+\s]/g, "")}`} target="_blank" rel="noreferrer" data-testid="footer-whatsapp-link" className="flex items-center gap-3 hover:text-[#D4AF37]">
                <MessageCircle size={16} className="text-[#D4AF37]" /> WhatsApp
              </a>
            </li>
          </ul>
          <div className="mt-8 flex flex-col gap-2 text-sm">
            <Link to="/reserver" className="text-[#D4AF37] hover:underline">Réserver une table</Link>
            <Link to="/terrasse-evenements" className="text-[#D4AF37] hover:underline">Événements privés</Link>
            <Link to="/qr-menu" className="text-[#D4AF37] hover:underline">QR Code du menu</Link>
          </div>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 text-center text-xs text-gray-500">
        © {new Date().getFullYear()} Italian Club — Champs-sur-Marne. Tous droits réservés.
      </div>
    </footer>
  );
}
